import __request__ from "routing/request";
export function naturalDateTester(string, timezone, requestOptions) {
  return __request__("GET", "/tools/natural_date_tester", null, { "string": string, "timezone": timezone }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
